import React, { createContext, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import { setUsers } from "../redux/slices/SocketSlice";
import { fetchUserDetailsThunk } from "../redux/slices/userSlice";

const SocketContext = createContext();

const backendUrl =
  process.env.REACT_APP_SOCKET_BACKEND_URL || "http://localhost:7000";

// Create socket instance outside the component to reuse it
const socket = io(backendUrl);

export const SocketProvider = ({ children }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const userDetailsStatus = useSelector(
    (state) => state.user.userDetails.status
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && user.UserID && userDetailsStatus === "away") {
      dispatch(fetchUserDetailsThunk(user.UserID));
    }
  }, [user, userDetailsStatus]);

  useEffect(() => {
    // Always listen for online-users to keep users updated
    socket.on("online-users", (users) => {
      // console.log("Received online-users:", users);
      dispatch(setUsers(users));
    });

    if (user) {
      socket.disconnect();
      socket.io.opts.query = {
        userId: user.UserID,
        // userName: user.FirstName + " " + user.LastName || `User${user.UserID}`,
      };
      socket.connect();
      socket.emit("user-logged-in", user.UserID);
      socket.on("receive-message", (message) => {
        console.log("receive-message:", message);
      });
      socket.on("updateParent", (message) => {
        console.log("updateParent:", message);
      });
      socket.on("new-message", (message) => {
        console.log("new-message:", message);
      });

      // ✅ --- Add away/active detection here ---
      let awayTimer;
      const IDLE_TIME = 5 * 60 * 1000; // 5 minutes

      const markIdle = () => {
        socket.emit("user-away", user.UserID);
      };

      const resetIdleTimer = () => {
        clearTimeout(awayTimer);
        socket.emit("user-active", user.UserID);
        awayTimer = setTimeout(markIdle, IDLE_TIME);
      };

      const activityEvents = ["mousemove", "keydown", "scroll", "click"];
      activityEvents.forEach((event) =>
        window.addEventListener(event, resetIdleTimer)
      );

      resetIdleTimer(); // initialize timer

      // Cleanup listeners & timer on unmount
      return () => {
        activityEvents.forEach((event) =>
          window.removeEventListener(event, resetIdleTimer)
        );
        clearTimeout(awayTimer);
        socket.off("online-users");
        socket.off("receive-message");
        socket.off("new-message");
        if (!user) socket.disconnect();
      };
    } else {
      socket.disconnect();
    }
  }, [user]);

  const sendNewMessage = (messageForm) => {
    if (user) socket.emit("send-message", messageForm);
  };
  const updateCurrentParent = (outGoing) => {
    if (user) socket.emit("updateParent", outGoing);
  };

  const handleTyping = (Id) => {
    if (user) socket.emit("typing", `${Id} is typing`, Id);
  };

  const onMessageReceived = (message) => message;
  const onNewMessage = (message) => message;

  return (
    <SocketContext.Provider
      value={{
        socket,
        sendNewMessage,
        updateCurrentParent,
        onMessageReceived,
        onNewMessage,
        handleTyping,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
